<template>
  <div>
    <v-data-table
      :items="corporation.loyalty_items"
      :headers="headers"
      sort-by="lp_cost"
      :loading="loading"
    >
      <template v-slot:item.type_id="{ item }">
        <v-tooltip top nudge-top="10" max-width="400">
          <template v-slot:activator="{ on }">
            <template v-if="types.find(x => x.type_id == item.type_id).name.includes('Blueprint')">
              <img :src="bpcUrl(item.type_id)" v-on="on" />
            </template>
            <template v-else-if="types.find(x => x.type_id == item.type_id).name.includes('SKIN')">
              <img src="../assets/skins.png" v-on="on" />
            </template>
            <template v-else>
              <img :src="iconUrl(item.type_id)" v-on="on" />
            </template>
          </template>
          <span>{{ types.find(x => x.type_id == item.type_id).name }}</span>
        </v-tooltip>
        
      </template>
      <template v-slot:item.lp_cost="{ item }">
        {{ item.lp_cost | add_commas }}
      </template>
      <template v-slot:item.isk_cost="{ item }">
        {{ item.isk_cost | add_commas }}
      </template>
    </v-data-table>
    <v-btn @click="loadLoyaltyStore">
      {{ !corporation.loyalty_items ? "Load" : "Refresh" }} loyalty store items
    </v-btn>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "LoyaltyStore",
  props: {
    corp_id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      headers: [
        { text: "Item", value: "type_id" },
        { text: "LP Cost", value: "lp_cost" },
        { text: "ISK Cost", value: "isk_cost" }
      ]
    }
  },
  computed: {
    ...mapState({
      corporation(state) {
        const corp = state.corporations
          .find(x => x.corporation_id == this.corp_id);
        return corp;
      },
      types(state) {
        const corp = state.corporations
          .find(x => x.corporation_id == this.corp_id);
        const type_ids = corp.loyalty_items.map(x => x.type_id);
        return state.types.filter(x => type_ids.includes(x.type_id));
      }
    })
  },
  methods: {
    loadLoyaltyStore() {
      this.loading = true;
      this.$store.dispatch("loadLoyaltyStore", this.corp_id)
        .then(() => this.loading = false);
    },
    iconUrl(type_id) {
      return `https://images.evetech.net/types/${type_id}/icon`;
    },
    bpcUrl(type_id) {
      return `https://images.evetech.net/types/${type_id}/bpc`;
    }
  }
}
</script>
